/* eslint-disable import/no-anonymous-default-export */
import StudentPendingLessons from './StudentPendingLessons';
import TeacherPendingLessons from './TeacherPendingLessons';

export default {
  Student: StudentPendingLessons,
  Teacher: TeacherPendingLessons,
};
